import { Injectable } from '@angular/core';
import { AppleDevice, IntegrationMDMDevicesService, IntegrationMDMProxyService } from '@era/locations-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { AppleDeviceApiActions, AppleDeviceContainerActions, DeviceContextMenuActions } from './apple-device.actions';

@Injectable()
export class AppleDeviceEffects {
  constructor(
    private readonly integrationMDMProxyService: IntegrationMDMProxyService,
    private readonly appleDeviceService: IntegrationMDMDevicesService,
    private readonly actions$: Actions
  ) {}

  appleDeviceLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppleDeviceContainerActions.appleDeviceRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleDeviceService.getAppleDevice(udid),
          (appleDevice: AppleDevice) => AppleDeviceApiActions.appleDeviceLoaded({ appleDevice }),
          (error) => AppleDeviceApiActions.appleDeviceLoadedError({ error })
        )
      )
    );
  });

  deviceLostModeEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeviceContextMenuActions.deviceLostModeCommandSent),
      mergeMap(({ udid, enableLostModeCommand }) =>
        safeMap(
          this.integrationMDMProxyService.queueEnableLostModeCommand(udid, enableLostModeCommand),
          (commandProgress) => AppleDeviceApiActions.devicePutInLostMode({ udid: commandProgress.udid }),
          (error) => AppleDeviceApiActions.failedToPutDeviceIntoLostMode({ error })
        )
      )
    );
  });

  deviceDisableLostModeEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeviceContextMenuActions.deviceDisableLostModeCommandSent),
      mergeMap(({ udid }) =>
        safeMap(
          this.integrationMDMProxyService.queueDisableLostModeCommand(udid),
          (commandProgress) => AppleDeviceApiActions.deviceTakenOutOfLostMode({ udid: commandProgress.udid }),
          (error) => AppleDeviceApiActions.failedToTakeDeviceOutOfLostMode({ error })
        )
      )
    );
  });
}
